/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum TaxDeclarationStatus {
  NotStarted = 'NotStarted',
  InExtraction = 'InExtraction',
  InProgress = 'InProgress',
  SmzhInReview = 'SmzhInReview',
  MissingData = 'MissingData',
  Complete = 'Complete',
  ClientSubmitted = 'ClientSubmitted',
  ClientInReview = 'ClientInReview',
  ClientAccepted = 'ClientAccepted',
  SentToClient = 'SentToClient',
  Cancelled = 'Cancelled',
  Deleted = 'Deleted',
  ClientRejected = 'ClientRejected'
}
